import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { Transition }               from '@uirouter/core';

import { GroupModel }                 from './typings/group-rights.group';
import { GroupRightModel }            from './typings/group-right';
import { GroupRightsComponent }       from './group-rights.component';
import { GroupRightsGroupsComponent } from './group-rights.groups.component';
import { GroupRightsService }         from './group-rights.service';

export const GroupRightsStates : Array<NgHybridStateDeclaration> = [
  {
    component: GroupRightsGroupsComponent,
    name     : 'app.group-rights-groups',
    resolve  : [
      {
        deps     : [ GroupRightsService ],
        resolveFn: ( groupsService : GroupRightsService ) : Promise<Array<GroupModel>> => groupsService.get(),
        token    : 'groups'
      }
    ],
    url: '/group-rights'
  },
  {
    component: GroupRightsComponent,
    name     : 'app.group-rights',
    resolve  : [
      {
        deps     : [ GroupRightsService, Transition ],
        resolveFn: ( groupsService : GroupRightsService, transitionService : Transition ) : Promise<GroupModel> =>  groupsService.getRights({
            group_name: transitionService.params().group_name
          }),
        token: 'group'
      },
      {
        deps     : [ GroupRightsService ],
        resolveFn: ( groupsService : GroupRightsService ) : Promise<Array<GroupModel>> => groupsService.get(),
        token    : 'groups'
      },
      {
        deps     : [ GroupRightsService ],
        resolveFn: ( groupsService : GroupRightsService ) : Promise<Array<GroupRightModel>> => groupsService.getAllRights(),
        token    : 'rights'
      }
    ],
    url: '/group-rights/:group_name'
  }
];
